module.exports = {
    "collectionLabel": `Suggesties`
};


//# sourceMappingURL=nl-NL.main.js.map
